@if (assessment && (assessment.assessment || assessment.reason)) {
  <div class="assessment-display">
    @if (assessment.assessment != null) {
      <div class="assessment-label">評価: {{ assessment.assessment }}</div>
    }
    @if (assessment.reason != null) {
      <div class="assessment-reason">理由: {{ assessment.reason }}</div>
    }
    @if (assessment.reasonDetail != null) {
      <div class="assessment-reason-detail">{{ assessment.reasonDetail }}</div>
    }
    @if (assessment.score != null) {
      <div class="assessment-score">スコア: {{ assessment.score }}</div>
    }
  </div>
}
